"use client";

import React from "react";
import { Facebook, Instagram, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        <li data-index={0}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors font-sans text-sm">
            About Us
          </Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors font-sans text-sm">
            Packages
          </Link>
        </li>
        <li data-index={2}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors font-sans text-sm">
            Blog
          </Link>
        </li>
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-sans text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function KgViagensRodape() {
  const contactInfo = [{
    icon: Phone,
    text: "+55 48 98822-1618",
    href: "tel:+5548988221618"
  }, {
    icon: MapPin,
    text: "Florianópolis, Brazil",
    href: "#"
  }];
  const socialLinks = [{
    icon: Instagram,
    label: "Instagram",
    href: "https://instagram.com"
  }, {
    icon: Facebook,
    label: "Facebook",
    href: "https://facebook.com"
  }];
  return <footer id="kg-viagens-rodapé" className="bg-background text-foreground border-t border-border pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-10">
          <Link to="/">
            
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-16">
          
          {}
          
          

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default font-semibold text-lg text-foreground">Acesso Rápido</h3>
            <MenuProvider menu_id="44">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default font-semibold text-lg text-foreground">Fale Conosco</h3>
            <ul className="flex flex-col gap-4">
              {contactInfo.map((item, i) => {
              const Icon = item.icon;
              return <li key={i} data-index={i} className="flex items-start gap-3">
                    <Icon className="size-5 text-primary shrink-0 mt-0.5" />
                    {item.href !== "#" ? <Link to={item.href} className="text-muted-foreground hover:text-primary transition-colors font-sans text-sm">
                        {item.text}
                      </Link> : <span className="text-muted-foreground font-sans text-sm">
                        {item.text}
                      </span>}
                  </li>;
            })}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default font-semibold text-lg text-foreground">Redes Sociais</h3>
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} newTab className="bg-muted hover:bg-primary hover:text-primary-foreground text-muted-foreground p-2.5 rounded-lg transition-all duration-300" aria-label={social.label}>
                    <Icon className={`size-5 ${social.label === "Instagram" ? "text-pink-600" : "text-blue-600"}`} />
                  </Link>;
            })}
            </div>
          </div>

        </div>

        <Separator className="mb-8" />
        
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <p className="text-sm text-muted-foreground font-sans">
            © {new Date().getFullYear()} KG Viagens. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground font-sans">
            Designed for premium travel experiences.
          </p>
        </div>
      </div>
    </footer>;
}